export const COOKIES = {
  HDSESSION: 'HDSESSION',
};
